<select
  class="form-control"
  (change)="onChange($event.target.value)"
  [disabled]="pages.length === 1"
  [class.text-muted]="pages.length === 1"
>
  <option [value]="p" *ngFor="let p of pages" [selected]="p === page">
    {{ p }}
  </option>
</select>
